import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './session-timeout-dialog.component.html',
})
export class SessionTimeoutDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SessionTimeoutDialogComponent>);
  readonly data = inject<{ countdown: number }>(MAT_DIALOG_DATA);

  readonly countdown = signal(this.data.countdown);

  updateCountdown(seconds: number): void {
    this.countdown.set(seconds);
  }

  staySignedIn(): void {
    this.dialogRef.close('stay');
  }

  signOut(): void {
    this.dialogRef.close('logout');
  }
}
